import React, {useState} from 'react';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import {useTranslation} from 'react-i18next';
import {permissionObj} from '../../../../../Helpers/permission';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {HorizontalRule} from '@mui/icons-material';
import TableFunction from '../../../../../components/table/TableFunction';
import {useSelector} from 'react-redux';
import {getDateFormat} from '../../../../../Apis/functions';

const Step7CardTable = ({ data, selectedList, setSelectedList, excludedId, handleItem, setIsAllChecked }) => {
    const { t } = useTranslation();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const [tableId, setTableId] = useState("tbl_s7ct_table");
    const [searchId, setSearchId] = useState("tbl_s7ct_search_id");

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} className='first_head'>{t('number')}</CustomTh>,
            <CustomTh tableId={tableId}> {t('facility_code')}</CustomTh>,
            <CustomTh tableId={tableId}> {t('format')}</CustomTh>,
            <CustomTh tableId={tableId}> {t('created_at')}</CustomTh>
        ];
    }

    const getTbody = () => {
        if(!data || data?.length === 0) return {
            body: [],
            data: []
        };
        let body = data.map((item) => {
            if (!excludedId.includes(item.id)) {
                return (
                    <>
                        <CustomTd className='first-column'>{item?.number}</CustomTd>
                        <CustomTd>{item?.facilityCode}</CustomTd>
                        <CustomTd>{item?.cardTypeName}</CustomTd>
                        <CustomTd>
                            {getDateFormat(item?.createdAt, true)}
                        </CustomTd>
                    </>
                );
            }
            return null;
        })

        return {
            body: body,
            data: data
        }
    };

    const getActionsButtons = (item, index) => {
        return <>
            { (DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE)) ? (
                <DropDownMenuProfile
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    menuId={`menu-${item.id}`}
                >
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={item?.templateId !== null ? 'preview' : 'no_template'}
                        icon={item?.templateId !== null ? <VisibilityIcon fontSize='small' /> :  <HorizontalRule fontSize='small' /> }
                        click={() =>  {
                            handleItem(item);
                        }}
                    />
                </DropDownMenuProfile>
            ) : <></>
            }
        </>;
    }

    const {thead,tbody,handleCheckboxChange, handleDeleteAll,
        openMenu, handleMenuToggle, handleClose} = TableFunction({
        selectedList,
        setSelectedList: setSelectedList,
        data: { content: data },
        getTbody: getTbody,
        getThead: getThead,
        setIsAllChecked
    });


    return {
        t,
        DEV,
        thead,
        tbody,
        tableId,
        searchId,
        handleDeleteAll,
        handleCheckboxChange,
        getActionsButtons
    };

}
export default Step7CardTable;
